const activities = [
  {
    id: 1,
    user: 'María González',
    action: 'actualizó el estado de',
    target: 'OP-2024-1847',
    status: 'En Tránsito',
    time: '5 min',
    avatar: 'MG',
  },
  {
    id: 2,
    user: 'Carlos Ramírez',
    action: 'registró nuevo cliente',
    target: 'Importadora del Pacífico S.A.',
    status: 'Activo',
    time: '23 min',
    avatar: 'CR',
  },
  {
    id: 3,
    user: 'Ana Martínez',
    action: 'generó factura',
    target: 'FC-2024-0923',
    status: 'Pendiente',
    time: '1 hora',
    avatar: 'AM',
  },
  {
    id: 4,
    user: 'Roberto Silva',
    action: 'subió documento a',
    target: 'OP-2024-1839',
    status: 'Completado',
    time: '2 horas',
    avatar: 'RS',
  },
  {
    id: 5,
    user: 'Laura Pérez',
    action: 'aprobó pago de',
    target: 'FC-2024-0918',
    status: 'Pagado',
    time: '3 horas',
    avatar: 'LP',
  },
];

const statusColors: Record<string, string> = {
  'En Tránsito': 'bg-[#EAF2F8] text-[#2F80ED]',
  'Activo': 'bg-green-50 text-[#10B981]',
  'Pendiente': 'bg-yellow-50 text-[#EAB308]',
  'Completado': 'bg-green-50 text-[#10B981]',
  'Pagado': 'bg-green-50 text-[#10B981]',
};

export default function RecentActivity() {
  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-[#0A2A43]">Actividad Reciente</h3>
        <button className="text-sm text-[#2F80ED] font-medium hover:underline cursor-pointer whitespace-nowrap">
          Ver todo
        </button>
      </div>

      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-start gap-3 pb-4 border-b border-gray-100 last:border-0">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-semibold text-sm flex-shrink-0">
              {activity.avatar}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-[#0A2A43]">
                <span className="font-semibold">{activity.user}</span>{' '}
                <span className="text-[#6B7280]">{activity.action}</span>{' '}
                <span className="font-semibold">{activity.target}</span>
              </p>
              <div className="flex items-center gap-2 mt-2">
                <span className={`px-2 py-1 text-xs font-medium rounded-md ${statusColors[activity.status]}`}>
                  {activity.status}
                </span>
                <span className="text-xs text-[#6B7280]">Hace {activity.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}